import { Skeleton } from '@mui/material'
import { DOC_TEMPLATES } from '../../constants'
import { IconType } from 'react-icons'
import { LuCheck, LuLoaderCircle } from 'react-icons/lu'

const GeneratingEssay = ({
	loadingSteps,
	loadingDots,
	loadingStatusIndex,
}: {
	loadingSteps: { label: string; description: string; icon: IconType }[]
	loadingDots: string
	loadingStatusIndex: number
}) => {
	return (
		<>
			<div className="flex flex-col gap-2 mt-8 relative">
				{/* Mobile view - show only current step centered */}
				<div className="flex justify-center md:hidden absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 py-2 px-5 border border-gray-200 rounded-lg w-72 bg-white z-10">
					{loadingSteps[loadingStatusIndex] && (
						<div className="flex gap-2 rounded-md p-2 max-w-sm">
							<div className="flex flex-col gap-0.5 items-center">
								<div className="flex gap-1 items-center">
									<div className="text-gray-900 font-semibold text-xl">
										{loadingSteps[loadingStatusIndex].label}
										{loadingDots}
									</div>
								</div>
								<div className="text-sm text-gray-600 text-center font-medium">
									{loadingSteps[loadingStatusIndex].description}
								</div>
							</div>
						</div>
					)}
				</div>

				{/* Desktop view - show all steps in grid */}
				<div
					className="hidden md:grid gap-2 w-full overflow-hidden"
					style={{ gridTemplateColumns: `repeat(${loadingSteps.length}, 1fr)` }}
				>
					{loadingSteps.map((step, index) => (
						<div key={index} className="flex gap-2 bg-gray-100 rounded-md p-2">
							<div className="h-8 w-8 bg-white rounded-full flex items-center justify-center shrink-0">
								{loadingStatusIndex === index
									? LuLoaderCircle({ className: 'w-5 h-5 animate-spin text-link' })
									: loadingStatusIndex > index
									? LuCheck({ className: 'w-5 h-5 text-gray-700' })
									: step.icon({ className: 'w-5 h-5 text-gray-700' })}
							</div>
							<div className="flex flex-col gap-0.5">
								<div className="text-sm text-gray-900 font-semibold">{step.label}</div>
								<div className="text-xs text-gray-700">{step.description}</div>
							</div>
						</div>
					))}
				</div>
				<div className="bg-white mt-5">
					{[...Array(4)].map((_, index) => (
						<Skeleton key={index} variant="text" width="100%" height={40} animation="wave" />
					))}
				</div>
				<div className="bg-white mt-5">
					{[...Array(4)].map((_, index) => (
						<Skeleton key={index} variant="text" width="100%" height={40} animation="wave" />
					))}
				</div>
			</div>
			{/* <div className="mt-10 bg-white">
				{[...Array(10)].map((_, index) => (
					<Skeleton key={index} variant="text" width="100%" height={40} animation="wave" />
				))}
			</div>
			<div
				className={`w-72 absolute bg-white shadow z-10 top-64 left-[calc(50%-145px)] py-2 px-5 border border-gray-300 rounded`}
			>
				<h6 className="text-2xl text-center">
					{type === DOC_TEMPLATES.Outline ? 'Writing outline' : loadingSteps[loadingStatusIndex]}
					{loadingDots}
				</h6>
				<div className="text-gray-600 text-center">This may take up to a minute.</div>
			</div> */}
		</>
	)
}

export default GeneratingEssay
